import { queryKeys } from '@/react-query/constants';
import { createFeatureApi } from '@/shared/api';

export const shippingApi = createFeatureApi(queryKeys.shipping);

export const nomenclatorApi = createFeatureApi(queryKeys.shippingNomenclator);
